import { Navigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { adminLinks, memberLinks } from '@/lib/links';
import { useIsAdmin } from '@/lib/queries';
import { Spinner } from '@/components/Layout';

/**
 * Where a member's QR code leads when scanned with an ordinary camera: staff to the
 * member's record, their own household to their page. To check people in at an event,
 * use the Scan button on that event's desk instead.
 */
export function MemberCodePage() {
  const { code = '' } = useParams();
  const admin = useIsAdmin();
  const person = useQuery({
    queryKey: ['member-code', code],
    queryFn: async () => {
      const { data } = await supabase.from('person').select('id').eq('member_code', code.toLowerCase()).maybeSingle();
      return (data as { id: string } | null) ?? null;
    },
  });
  if (person.isLoading || admin.isLoading) return <Spinner />;
  if (person.data) return <Navigate to={admin.data ? adminLinks.person(person.data.id) : memberLinks.person(person.data.id)} replace />;
  return (
    <div className="card mx-auto max-w-lg space-y-2">
      <h1 className="text-2xl">EGKA member card</h1>
      <p>This is an EGKA member's code. Show it at the check-in desk at EGKA events.</p>
      <p className="text-sm text-ink-500">Working on the desk? Open the event's check-in desk and use its Scan button.</p>
    </div>
  );
}
